export default "/_next/static/media/tutorial-01.178d7e92ff07bb594e0599339e1b5f63.jpg";